'use client';
"use strict";

var _excluded = ["name", "getInitials"],
    _excluded2 = ["src", "srcSet", "name", "showBorder", "borderRadius", "onError", "onLoad", "getInitials", "icon", "iconLabel", "loading", "children", "borderColor", "ignoreFallback", "crossOrigin", "referrerPolicy"],
    _excluded3 = ["placement", "className"],
    _excluded4 = ["children", "borderColor", "max", "spacing", "borderRadius"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Avatar: function Avatar() {
    return _Avatar;
  },
  AvatarBadge: function AvatarBadge() {
    return _AvatarBadge;
  },
  AvatarGroup: function AvatarGroup() {
    return _AvatarGroup;
  },
  GenericAvatarIcon: function GenericAvatarIcon() {
    return _GenericAvatarIcon;
  },
  useAvatarStyles: function useAvatarStyles() {
    return _useAvatarStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/avatar.tsx

var import_system4 = require("@chakra-ui/system");

var import_shared_utils = require("@chakra-ui/shared-utils"); // src/avatar-context.tsx


var import_react_context = require("@chakra-ui/react-context");

var _ref = (0, import_react_context.createContext)({
  name: "AvatarStylesContext",
  hookName: "useAvatarStyles",
  providerName: "<Avatar/>"
}),
    _ref2 = _slicedToArray(_ref, 2),
    AvatarStylesProvider = _ref2[0],
    _useAvatarStyles = _ref2[1]; // src/avatar-image.tsx


var import_image = require("@chakra-ui/image");

var import_system3 = require("@chakra-ui/system");

var import_react = require("react"); // src/avatar-name.tsx


var import_system = require("@chakra-ui/system");

var import_jsx_runtime = require("react/jsx-runtime");

function initials(name) {
  var _a;

  var names = name.split(" ");
  var firstName = (_a = names[0]) != null ? _a : "";
  var lastName = names.length > 1 ? names[names.length - 1] : "";
  return firstName && lastName ? "".concat(firstName.charAt(0)).concat(lastName.charAt(0)) : firstName.charAt(0);
}

function AvatarName(props) {
  var name = props.name,
      getInitials = props.getInitials,
      rest = _objectWithoutProperties(props, _excluded);

  var styles = _useAvatarStyles();

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
    role: "img",
    "aria-label": name
  }, rest), {}, {
    __css: styles.label,
    children: name ? getInitials == null ? void 0 : getInitials(name) : null
  }));
}

AvatarName.displayName = "AvatarName"; // src/generic-avatar-icon.tsx

var import_system2 = require("@chakra-ui/system");

var import_jsx_runtime2 = require("react/jsx-runtime");

var _GenericAvatarIcon = function _GenericAvatarIcon(props) {
  return /* @__PURE__ */(0, import_jsx_runtime2.jsxs)(import_system2.chakra.svg, _objectSpread(_objectSpread({
    viewBox: "0 0 128 128",
    color: "#fff",
    width: "100%",
    height: "100%",
    className: "chakra-avatar__svg"
  }, props), {}, {
    children: [/* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
    }), /* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
    })]
  }));
}; // src/avatar-image.tsx


var import_jsx_runtime3 = require("react/jsx-runtime");

function AvatarImage(props) {
  var src = props.src,
      srcSet = props.srcSet,
      onError = props.onError,
      onLoad = props.onLoad,
      getInitials = props.getInitials,
      name = props.name,
      borderRadius = props.borderRadius,
      loading = props.loading,
      iconLabel = props.iconLabel,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_GenericAvatarIcon, {}) : _props$icon,
      ignoreFallback = props.ignoreFallback,
      referrerPolicy = props.referrerPolicy,
      crossOrigin = props.crossOrigin;
  var status = (0, import_image.useImage)({
    src: src,
    onError: onError,
    crossOrigin: crossOrigin,
    ignoreFallback: ignoreFallback
  });
  var hasLoaded = status === "loaded";
  var showFallback = !src || !hasLoaded;

  if (showFallback) {
    return name ? /* @__PURE__ */(0, import_jsx_runtime3.jsx)(AvatarName, {
      className: "chakra-avatar__initials",
      getInitials: getInitials,
      name: name
    }) : (0, import_react.cloneElement)(icon, {
      role: "img",
      "aria-label": iconLabel
    });
  }

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.img, {
    src: src,
    srcSet: srcSet,
    alt: name,
    onLoad: onLoad,
    referrerPolicy: referrerPolicy,
    crossOrigin: crossOrigin != null ? crossOrigin : void 0,
    className: "chakra-avatar__img",
    loading: loading,
    __css: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: borderRadius
    }
  });
}

AvatarImage.displayName = "AvatarImage"; // src/avatar.tsx

var import_react2 = require("react");

var import_jsx_runtime4 = require("react/jsx-runtime");

var baseStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  textTransform: "uppercase",
  fontWeight: "medium",
  position: "relative",
  flexShrink: 0
};

var _Avatar = (0, import_system4.forwardRef)(function (props, ref) {
  var styles = (0, import_system4.useMultiStyleConfig)("Avatar", props);

  var _ref3 = (0, import_react2.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isLoaded = _ref4[0],
      setIsLoaded = _ref4[1];

  var _ref5 = (0, import_system4.omitThemingProps)(props),
      src = _ref5.src,
      srcSet = _ref5.srcSet,
      name = _ref5.name,
      showBorder = _ref5.showBorder,
      _ref5$borderRadius = _ref5.borderRadius,
      borderRadius = _ref5$borderRadius === void 0 ? "full" : _ref5$borderRadius,
      onError = _ref5.onError,
      onLoadProp = _ref5.onLoad,
      _ref5$getInitials = _ref5.getInitials,
      getInitials = _ref5$getInitials === void 0 ? initials : _ref5$getInitials,
      _ref5$icon = _ref5.icon,
      icon = _ref5$icon === void 0 ? /* @__PURE__ */(0, import_jsx_runtime4.jsx)(_GenericAvatarIcon, {}) : _ref5$icon,
      _ref5$iconLabel = _ref5.iconLabel,
      iconLabel = _ref5$iconLabel === void 0 ? " avatar" : _ref5$iconLabel,
      loading = _ref5.loading,
      children = _ref5.children,
      borderColor = _ref5.borderColor,
      ignoreFallback = _ref5.ignoreFallback,
      crossOrigin = _ref5.crossOrigin,
      referrerPolicy = _ref5.referrerPolicy,
      rest = _objectWithoutProperties(_ref5, _excluded2);

  var avatarStyles = _objectSpread(_objectSpread({
    borderRadius: borderRadius,
    borderWidth: showBorder ? "2px" : void 0
  }, baseStyle), styles.container);

  if (borderColor) {
    avatarStyles.borderColor = borderColor;
  }

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.span, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: (0, import_shared_utils.cx)("chakra-avatar", props.className),
    "data-loaded": (0, import_shared_utils.dataAttr)(isLoaded),
    __css: avatarStyles,
    children: /* @__PURE__ */(0, import_jsx_runtime4.jsxs)(AvatarStylesProvider, {
      value: styles,
      children: [/* @__PURE__ */(0, import_jsx_runtime4.jsx)(AvatarImage, {
        src: src,
        srcSet: srcSet,
        loading: loading,
        onLoad: (0, import_shared_utils.callAllHandlers)(onLoadProp, function () {
          setIsLoaded(true);
        }),
        onError: onError,
        getInitials: getInitials,
        name: name,
        borderRadius: borderRadius,
        icon: icon,
        iconLabel: iconLabel,
        ignoreFallback: ignoreFallback,
        crossOrigin: crossOrigin,
        referrerPolicy: referrerPolicy
      }), children]
    })
  }));
});

_Avatar.displayName = "Avatar"; // src/avatar-badge.tsx

var import_system5 = require("@chakra-ui/system");

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_jsx_runtime5 = require("react/jsx-runtime");

var placementMap = {
  "top-start": {
    top: "0",
    insetStart: "0",
    transform: "translate(-25%, -25%)"
  },
  "top-end": {
    top: "0",
    insetEnd: "0",
    transform: "translate(25%, -25%)"
  },
  "bottom-start": {
    bottom: "0",
    insetStart: "0",
    transform: "translate(-25%, 25%)"
  },
  "bottom-end": {
    bottom: "0",
    insetEnd: "0",
    transform: "translate(25%, 25%)"
  }
};

var _AvatarBadge = (0, import_system5.forwardRef)(function AvatarBadge2(props, ref) {
  var _props$placement = props.placement,
      placement = _props$placement === void 0 ? "bottom-end" : _props$placement,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded3);

  var styles = _useAvatarStyles();

  var placementStyles = placementMap[placement];

  var badgeStyles = _objectSpread(_objectSpread({
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, placementStyles), styles.badge);

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system5.chakra.div, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    className: (0, import_shared_utils2.cx)("chakra-avatar__badge", className),
    __css: badgeStyles
  }));
});

_AvatarBadge.displayName = "AvatarBadge"; // src/avatar-group.tsx

var import_system6 = require("@chakra-ui/system");

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_react_children_utils = require("@chakra-ui/react-children-utils"); // ../../utilities/object-utils/src/compact.ts


function compact(object) {
  var clone = Object.assign({}, object);

  for (var key in clone) {
    if (clone[key] === void 0) delete clone[key];
  }

  return clone;
} // src/avatar-group.tsx


var import_react3 = require("react");

var import_jsx_runtime6 = require("react/jsx-runtime");

var _AvatarGroup = (0, import_system6.forwardRef)(function AvatarGroup2(props, ref) {
  var styles = (0, import_system6.useMultiStyleConfig)("Avatar", props);

  var _ref6 = (0, import_system6.omitThemingProps)(props),
      children = _ref6.children,
      borderColor = _ref6.borderColor,
      max = _ref6.max,
      _ref6$spacing = _ref6.spacing,
      spacing = _ref6$spacing === void 0 ? "-0.75rem" : _ref6$spacing,
      _ref6$borderRadius = _ref6.borderRadius,
      borderRadius = _ref6$borderRadius === void 0 ? "full" : _ref6$borderRadius,
      rest = _objectWithoutProperties(_ref6, _excluded4);

  var validChildren = (0, import_react_children_utils.getValidChildren)(children);
  var childrenWithinMax = max != null ? validChildren.slice(0, max) : validChildren;
  var excess = max != null ? validChildren.length - max : 0;
  var reversedChildren = childrenWithinMax.reverse();
  var clones = reversedChildren.map(function (child, index) {
    var _a;

    var isFirstAvatar = index === 0;
    var childProps = {
      marginEnd: isFirstAvatar ? 0 : spacing,
      size: props.size,
      borderColor: (_a = child.props.borderColor) != null ? _a : borderColor,
      showBorder: true
    };
    return (0, import_react3.cloneElement)(child, compact(childProps));
  });

  var groupStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row-reverse"
  }, styles.group);

  var excessStyles = _objectSpread(_objectSpread({
    borderRadius: borderRadius,
    marginStart: spacing
  }, baseStyle), styles.excessLabel);

  return /* @__PURE__ */(0, import_jsx_runtime6.jsxs)(import_system6.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    role: "group",
    __css: groupStyles
  }, rest), {}, {
    className: (0, import_shared_utils3.cx)("chakra-avatar__group", props.className),
    children: [excess > 0 && /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.span, {
      className: "chakra-avatar__excess",
      __css: excessStyles,
      children: "+".concat(excess)
    }), clones]
  }));
});

_AvatarGroup.displayName = "AvatarGroup"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Avatar: _Avatar,
  AvatarBadge: _AvatarBadge,
  AvatarGroup: _AvatarGroup,
  GenericAvatarIcon: _GenericAvatarIcon,
  useAvatarStyles: _useAvatarStyles
});